const initProps = {
  baseURL: 'lendthetrendmx.myshopify.com',
}

/**
* @type {{ quantity: number, variantId: number }[]}
*/
const lineItems = [
  {
    quantity: 1,
    variantId: 43908603216117,
  },
  {
    quantity: 1,
    variantId: 43908603183349,
  }
]

/**
* @param {{ baseURL: string }} initProps
* @param { lineItems } lineItems
* @param { attributes } attributes
* @param { string[] } discounts
* @returns string
*/
const createCheckoutPermalink = (initProps, lineItems, attributes, discounts = []) => {
  const items = lineItems.reduce((acc, el, index, array) => {
    const { quantity, variantId } = el
    let item = `${variantId}:${quantity}`

    if( index !== (array.length - 1) ) {
      item = item.concat(',')
    }

    return acc + item
  }, '')

  console.log({ items })

  const attributesAsString = Object.entries(attributes).reduce((acc, el, index, array) => {
    const [key, value] = el
    let attr = `attributes[${key}]=${value}`

    if( index !== (array.length - 1) ) {
      attr = attr.concat('&')
    }

    return acc + attr
  }, '')

  console.log({ attributesAsString })

  const discountString = (discounts.length > 0)
    ? `&discount=${discounts.join(',')}`
    : ''

  return `http://${initProps.baseURL}/cart/${items}?${attributesAsString}`+ discountString
}

/**
 * 
 * @param { Reservation [] } reservations 
 */
const createAttributes = (reservations = []) => {
  let index = 0

  const attributes = reservations.reduce((acc, reservation) => {
    console.log({ reservation })
    console.log({backupTitle: reservation?.backup.title})
    const key = `0${index+1}`

    acc[`${key}-Nombre`] = reservation.product.title
    acc[`${key}-Fecha_inicio`] = new Date(reservation.startDate).toLocaleDateString('es-MX')
    acc[`${key}-Duracion`] = `${reservation.rentPlanDurationInDays} días`,
    acc[`${key}-Backup`] = (!reservation.backup) ? 'Renta sin backup' : 'Cliente eligió backup',
    acc[`${key}-Tipo`] = 'Principal'
    acc[`${key}-id`] = reservation._id || ''
    
    if( reservation.backup && reservation.backup.title !== "Sin backup" ) {
      console.log('Adding backup info')
      index++
      const key = `0${index+1}`

      acc[`${key}-Nombre`] = reservation.backup.title
      acc[`${key}-Fecha_inicio`] = new Date(reservation.startDate).toLocaleDateString('es-MX')
      acc[`${key}-Duracion`] = `${reservation.rentPlanDurationInDays} días`,
      acc[`${key}-Backup`] = (!reservation.backup) ? 'Renta sin backup' : 'Cliente eligió backup',
      acc[`${key}-Tipo`] = 'Backup'
      acc[`${key}-id`] = reservation._id || ''
    }

    index++

    return acc
  }, {})

  return attributes
}
